import React from 'react';
import { MapPin, Phone, MessageCircle, Mail, Star } from 'lucide-react';
import { college } from '../../mock/data';

const CONTACT_ITEMS = [
  { id: 'ci-address', icon: MapPin, label: 'Address', value: college.address },
  { id: 'ci-call', icon: Phone, label: 'Call Us', value: college.phone, href: `tel:${college.phone.replace(/\s/g, '')}` },
  { id: 'ci-whatsapp', icon: MessageCircle, label: 'WhatsApp', value: college.phone, href: `https://wa.me/${college.phoneClean}` },
  { id: 'ci-email', icon: Mail, label: 'Email', value: college.email, href: `mailto:${college.email}` },
];

export default function ContactInfo() {
  return (
    <div className="lg:col-span-2 grid gap-4">
      {CONTACT_ITEMS.map((c) => {
        const Icon = c.icon;
        return (
          <a key={c.id} href={c.href || '#'} className="lift block rounded-2xl bg-white border border-[var(--pca-border)] p-5">
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-xl bg-[var(--pca-blue-soft)] text-[var(--pca-blue)] flex items-center justify-center shrink-0">
                <Icon size={20} />
              </div>
              <div>
                <div className="text-[12px] font-semibold uppercase tracking-widest text-slate-500">{c.label}</div>
                <div className="font-medium text-[#0B2E6E] mt-1">{c.value}</div>
              </div>
            </div>
          </a>
        );
      })}

      <div className="rounded-2xl bg-white border border-[var(--pca-border)] p-5">
        <div className="flex items-center gap-2 text-yellow-500">
          <Star size={18} fill="currentColor" />
          <span className="text-[#0B2E6E] font-bold">{college.rating}</span>
          <span className="text-slate-500 text-sm">/ 5.0</span>
        </div>
        <div className="mt-1 text-sm text-slate-600">{college.reviews}+ Google Reviews</div>
      </div>

      <div className="rounded-2xl overflow-hidden border border-[var(--pca-border)] shadow-sm">
        <iframe
          title="Pharmacy College Azamgarh Location"
          src="https://maps.google.com/maps?q=Itaura%20Chandeshwar%20Azamgarh%20Uttar%20Pradesh&t=&z=13&ie=UTF8&iwloc=&output=embed"
          className="w-full h-56"
          loading="lazy"
        />
      </div>
    </div>
  );
}
